<template>
  <v-select
    :class="['custom-tailwind-select', is_invalid]"
    v-model="selected_value"
    :reduce="(opt) => opt.id"
    :label="label ? label : 'name'"
    :options="options"
    :clearable="clearable"
    :multiple="multiple ? multiple : false"
    :disabled="disabled ? disabled : false"
  />
</template>
<script>
export default {
  name: "SelectForm",
  props: {
    options: {},
    label: {},
    modelValue: {},
    multiple: {},
    disabled: {},
    is_invalid: {},
    clearable: { type: Boolean, default: true },
  },
  data() {
    return {
      selected_value: this.modelValue,
    };
  },
  updated() {
    this.selected_value = this.modelValue;
  },
  watch: {
    selected_value: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>
